import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于51吃瓜网，你可能想了解的一切
          </p>
        </div>

        <div className="space-y-4">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <h3 className="font-medium text-foreground-900 text-sm md:text-base mb-3 flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold shrink-0 mt-0.5">
                  Q
                </span>
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-9">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}